var path = '/home/travis/build/orizens/echoes/src/components/search-filter-panel/search-filter-panel.html';
var html = "<div><ul class=\"navbar-nav nav\" id=search-presets><li class=btn-group><e-dropdown label=Presets items=$ctrl.presets on-select=$ctrl.updatePreset(item) icon=tag selected></e-dropdown></ul><ul class=\"navbar-nav nav\" id=duration-picker><li class=btn-group><e-dropdown label=Duration items=$ctrl.durations on-select=\"$ctrl.onDurationChange(item, index)\" icon=time selected></e-dropdown></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/search-filter-panel/search-filter-panel.html
 ** module id = 130
 ** module chunks = 1
 **/